<template>
  <form-builder-editor-field
    :item="item"
    :show-required="true"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    v-on="$listeners"
  />
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorCaseManager.vue?f982f130